import * as React from "react";
const SvgDownloadIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.1667 14.1666H14.175M14.5 11.6666H15C15.7766 11.6666 16.1649 11.6666 16.4711 11.7935C16.8795 11.9627 17.204 12.2871 17.3731 12.6955C17.5 13.0018 17.5 13.3901 17.5 14.1666C17.5 14.9432 17.5 15.3315 17.3731 15.6378C17.204 16.0462 16.8795 16.3706 16.4711 16.5398C16.1649 16.6666 15.7766 16.6666 15 16.6666H5C4.22343 16.6666 3.83515 16.6666 3.52886 16.5398C3.12048 16.3706 2.79602 16.0462 2.62687 15.6378C2.5 15.3315 2.5 14.9432 2.5 14.1666C2.5 13.3901 2.5 13.0018 2.62687 12.6955C2.79602 12.2871 3.12048 11.9627 3.52886 11.7935C3.83515 11.6666 4.22343 11.6666 5 11.6666H5.5M10 12.5V3.33331M10 12.5L7.5 9.99998M10 12.5L12.5 9.99998",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDownloadIcon;
